import React from "react";
import user from "../img/dontuser.png";
import { logOut } from '../action/MainAction';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useI18n } from '../i18n/I18nContext';
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
      headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
      }
  };
};
const DontActiveAcount = ({ token, logOut,sil }) => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const handleClick = async () => {
    await logOut();
    localStorage.removeItem("token");
    localStorage.removeItem('role');
    localStorage.removeItem('staff_role');
    navigate("/");
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-80 z-50">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full relative">
        <button onClick={()=>(handleClick(),sil(false))}
          // onClick={() => onClose(false)}
          className="absolute top-3 right-3 text-gray-600 hover:text-gray-900"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className="text-center mb-6">
          <img
            src={user}
            alt="Access Denied"
            className="w-20 h-20 mx-auto mb-4"
          />
        </div>
        <div className="text-center text-lg font-medium text-gray-800">
          <p className="mb-2 text-xl font-semibold text-red-600">{t('inactive.title')}</p>
          <p className="text-gray-600 text-base">
            {t('inactive.text')}
          </p>
          <div className="mt-6 flex justify-center">
            <button 
              onClick={() => (handleClick(), sil(false))}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition duration-200"
            >
              {t('inactive.ok')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.Data.token,
});

const mapDispatchToProps = {
  logOut,
};

export default connect(mapStateToProps, mapDispatchToProps)(DontActiveAcount);
// export default ;


